import React from "react";
import { Button } from "@headlessui/react";
import { useFirebase } from "../FbContex";

const UserPanel = () => {
  const { signOut, user } = useFirebase();
  return (
    <>
      <div className="text-center py-3">
        <p className="py-3">{user?.email as string}</p>
        <img
          width={60}
          height={60}
          className="mx-auto size-24 rounded-full ring-2 ring-white"
          src={user?.photoURL as string}
          alt="avatar"
        />
        <p className="py-3">Hi, {user?.displayName as string}!</p>
      </div>
      <div className="p-3 text-center border-slate-500/50 border-t">
        <Button
          onClick={signOut}
          className="text-center w-48 gap-2 rounded-md bg-orange-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-red-600 data-[open]:bg-red-700 data-[focus]:outline-1 data-[focus]:outline-white"
        >
          Logout
        </Button>
      </div>
    </>
  );
};

export default UserPanel;
